export default __webpack_public_path__ + "static/media/Bark.227c7b19.webp";